import { render, staticRenderFns } from "./cabupdata.vue?vue&type=template&id=4f2f19ba&"
import script from "./cabupdata.vue?vue&type=script&lang=js&"
export * from "./cabupdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports